import {
  fetchTournament,
  updateTournamentIsPublic,
  updateTournamentName,
} from '../../entities/tournament';

export const scope = 'TOURNAMENT_SUPPORT';

export function fetchTournamentIfNeeded(tournamentId) {
  return (dispatch, getState) => {
    const {tournament} = getState().app.support;

    if (!tournament.info.isFetching)
      dispatch(fetchTournament(tournamentId, scope));
  };
}

export function updateNameTournament(payload) {
  return (dispatch, getState) => {
    const {tournament} = getState().app.support;

    if (!tournament.info.isFetching)
      dispatch(updateTournamentName(payload, scope));
  };
}

export function updateNameIsPublic(payload) {
  return (dispatch, getState) => {
    const {tournament} = getState().app.support;

    if (!tournament.info.isFetching)
      dispatch(updateTournamentIsPublic(payload, scope));
  };
}



// WEBPACK FOOTER //
// ./src/actions/app/support/tournament.js